import { OidcAccessToken, OidcClient, OidcTokenStorage, OidcUrlHelper } from '@ori/auth';

import { Config } from '../../helpers/Config';

interface Token {
  Token: string;
}
declare global {
  interface Token {
    Token: string;
  }
  interface TokenService {
    getToken: () => Promise<Token | null>;
  }
  interface Ori {
    tokenService?: TokenService;
  }
  interface Window {
    ori?: Ori;
  }
}
class TokenProvider {
  private readonly oidcTokenStorage: OidcTokenStorage = new OidcTokenStorage();
  async getToken(): Promise<OidcAccessToken> {
    if (window.ori?.tokenService) {
      let oriToken: Token | null = null;
      try {
        oriToken = await window.ori.tokenService.getToken();
      } catch {
        // silence is golden
      }
      if (oriToken) {
        return new OidcAccessToken(oriToken.Token);
      }
    }
    const token = this.oidcTokenStorage.getAccessToken();
    if (token) {
      return token;
    }
    throw new Error('Missing auth token');
  }

  hasToken = (): boolean => {
    if (window.ori?.tokenService) {
      return true;
    }

    return !!this.oidcTokenStorage.getAccessToken();
  };

  doLogin(): void {
    const config = Config.get();
    try {
      const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
      const oidcUrlHelper = new OidcUrlHelper();
      oidcUrlHelper.storeAuthCodeFromParams(searchParams);
    } catch {
      // nothing to see here
    }
    if (!this.hasToken()) {
      const oidcClient = new OidcClient(
        {
          callbackUrl: '#/',
          redirectUrl: '',
        },
        {
          acrValues: `tenant:${config.tenant}`,
          clientId: 'ImplicitTest-V2',
          identityUrl: 'https://identity-uat.oriflame.com',
          scope: 'openid profile user_identification',
        },
      );
      oidcClient.doLogin();
    }
  }
}
const tokenProvider = new TokenProvider();
export { tokenProvider as TokenProvider };
